import { ActionType } from './common-action-type';
import i18n from '@i18next/i18n';
import { ToolListType } from '@src/framework/editor/src/js/constants/toolbar-data';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
//  ------------侧边栏属性设置-------------------------

export const EffectPropertyItem =  [
    { id: ActionType.SHADOW,        title: i18n.t('阴影') },
    { id: ActionType.REFLECTION,    title: i18n.t('映像') },
    { id: ActionType.GLOW,          title: i18n.t('发光') },
    { id: ActionType.SOFTEDGE,      title: i18n.t('柔化边缘') },
];

//  空白处显示侧边栏属性菜单
export const BlankPropertyItems = [
    { id: ActionType.FILLCOLOR, title: i18n.t('填充'), isSlideBg: true },
];

// 通用侧边栏属性菜单
export const CommonPropertyItems: ToolListType[] = [
    { id: ActionType.SIZE_ADJUST, title: i18n.t('大小') },
    { id: ActionType.TEXT_ADJUST, title: i18n.t('文字') },
    { id: ActionType.FILLCOLOR, title: i18n.t('填充') },
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框') },
].concat(EffectPropertyItem);

// 连接线侧边栏属性菜单
export const ConnectorPropertyItems = [
    { id: ActionType.BORDERCOLOR, title: i18n.t('边框'), isConnector: true },
];
// .concat(EffectPropertyItem);

export const TablePropertyItems = [
    { id: ActionType.FILLCOLOR, title: i18n.t('填充') },
];
// .concat(EffectPropertyItem);

// 图片侧边栏属性
const ENABLE_PICTURE_ACTION = !config.supportEnterprise(EnterPriseType.ALL);
export const ImagePropertyItems = CommonPropertyItems.slice(0, 1).concat(CommonPropertyItems.slice(2), [
    ENABLE_PICTURE_ACTION && { id: ActionType.REGULATE, title: i18n.t('图片校正') },
    ENABLE_PICTURE_ACTION && { id: ActionType.PICTURE_COLOR, title: i18n.t('图片颜色') },
    { id: ActionType.INSERT_PICTURE, title: i18n.t('图片格式') },
].filter(Boolean) as ToolListType[]);

// 幻灯片备注侧边栏属性
export const NotePropertyItems = [];

// // 形状显示侧边栏属性菜单
// export const ShapePropertyItems = [
//     //额外添加
// ].concat(CommonPropertyItems)
//
//
// // 图片显示侧边栏属性菜单
// export const PicPropertyItems = [
//     //额外添加
// ].concat(CommonPropertyItems)
//
//
// // 图片显示侧边栏属性菜单
// export const PicPropertyItems = [
//     //额外添加
// ].concat(CommonPropertyItems)
